import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink';
import { TypedMemo } from '../../common/types';
import { ClickableDiv } from '../../common/views/ClickableDiv';
import { SMLBioLinkBoxRendererProps } from './props';
import styles from './SMLBioLinkBox.module.scss';

const SMLBioLinkBoxRendererComponent: React.FC<SMLBioLinkBoxRendererProps> = ({ onClick }) => {
  const intl = useIntl();
  return (
    <ClickableDiv onClick={onClick} className={styles.card} testID="ArtistPage">
      <div className={styles.thumb}>
        <FontAwesomeIcon icon={faLink} className={styles.thumbIcon} />
      </div>
      <div className={styles.body}>
        <div className={styles.bodyText}>
          <h6 className={styles.name}>
            {intl.formatMessage({ id: 'app.smart-links.list.bio-link-manage-title', defaultMessage: 'Bio Link' })}
          </h6>
          <div className={styles.sub}>
            {intl.formatMessage({
              id: 'app.smart-links.list.bio-link.sub',
              defaultMessage: 'Your artist page',
            })}
          </div>
        </div>
        <span className={styles.pill}>
          {intl.formatMessage({ id: 'app.smart-links.list.bio-link-manage', defaultMessage: 'Manage' })}
        </span>
      </div>
    </ClickableDiv>
  );
};

export const SMLBioLinkBoxRenderer = TypedMemo(SMLBioLinkBoxRendererComponent);
